import { defineComponent as _defineComponent } from 'vue'
import type { Category } from '@ilteducation/content-ref-data-types';
import { computed, ref } from 'vue';
import { getAllRefData } from '@/data-provider/refDataProvider';

type Props = {
  id: string;
  title: string;
  item: Category;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: Category;
}



const bookField = ref([
  { source: 'id', link: 'edit', label: 'ID', sortable: false },
  {
    source: 'isbn',
    label: 'ISBN',
    sortable: true,
  },
  {
    source: 'title',
    sortable: true,
  },
]);

const allCategories = ref<Category[]>([]);
getAllRefData('categories').then((categories) => {
  allCategories.value = categories;
});

const getCategoryLabelById = computed(() => (id: string) => {
  const category = allCategories.value.find((c) => c.id === id);
  if (!category) {
    return id;
  }
  return `${category.category} (${category.realms?.toString()})`;
});

return { __sfc: true,props, bookField, allCategories, getCategoryLabelById }
}

})